import React from 'react';
import { Button, Col, Row } from 'antd';
import { usePrinter } from '~/App/Layout/providers/PrinterProviderV2';

const PrinterBluetoothV2 = () => {
  const { bluetooth } = usePrinter();
  const { loading, device, connectNew, disconnect } = bluetooth;

  const printerName = device?.name || 'None';
  const status = device != null ? 'Connected' : 'Disconnected';

  return (
    <div>
      <div className="flex flex-col gap-2 mb-6 relative">
        <Row>
          <Col span={6}>Printer Name</Col>
          <Col span={18}>
            <b>{printerName}</b>
          </Col>
        </Row>
        <Row>
          <Col span={6}>Status</Col>
          <Col span={18}>
            <b>{status}</b>
          </Col>
        </Row>
      </div>
      <div className="flex flex-col gap-6">
        <Button
          type="primary"
          onClick={connectNew}
          size="large"
          block
          loading={loading}
        >
          Connect
        </Button>
        <Button
          danger
          onClick={disconnect}
          size="large"
          block
          disabled={!device}
        >
          Disconnect
        </Button>
      </div>
    </div>
  );
};

export default PrinterBluetoothV2;
